import { AdmissionGuideStruct } from "../../structs/private-billing/admission-guide.struct";
import { AppointmentGuideStruct } from "../../structs/private-billing/appointment-guide.struct";
import { FeesGuideStruct } from "../../structs/private-billing/fees-guide.struct";
import { SpSadtGuideStruct } from "../../structs/private-billing/sp-sadt-guide.struct";

export class GuideRequest {
    public feesGuideStruct: FeesGuideStruct;
    public admissionGuideStruct: AdmissionGuideStruct;
    public spSadtGuideStruct: SpSadtGuideStruct;
    public appointmentGuideStruct: AppointmentGuideStruct;
    public idEpisode: number;
}